import { useRef } from "react";
import { tickFraction, tickFromFraction } from "../state/markers";
import type { Beat } from "../types";

interface ScrubberProps {
  tick: number;
  maxTick: number;
  beats: Beat[];
  onSeek: (tick: number) => void;
}

export function Scrubber({ tick, maxTick, beats, onSeek }: ScrubberProps) {
  const host = useRef<HTMLDivElement>(null);
  const pct = (t: number) => `${tickFraction(t, maxTick) * 100}%`;
  const seekFromPointer = (clientX: number) => {
    const rect = host.current?.getBoundingClientRect();
    if (!rect || rect.width === 0) return;
    onSeek(tickFromFraction((clientX - rect.left) / rect.width, maxTick));
  };
  return (
    <div
      className="scrubber"
      ref={host}
      onClick={(e) => seekFromPointer(e.clientX)}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") onSeek(tick - 1);
        else if (e.key === "ArrowRight") onSeek(tick + 1);
        else if (e.key === "Home") onSeek(1);
        else if (e.key === "End") onSeek(maxTick);
        else return;
        e.preventDefault();
      }}
      tabIndex={0}
      role="slider"
      aria-valuemin={1}
      aria-valuemax={maxTick}
      aria-valuenow={tick}
      aria-label="replay position"
    >
      <div className="scrubber-track" />
      <div className="scrubber-fill" style={{ width: pct(tick) }} />
      {beats.map((beat, index) => (
        <button
          type="button"
          key={`${beat.tick}-${index}`}
          className="beat-marker"
          style={{ left: pct(beat.tick) }}
          title={`tick ${beat.tick}: ${beat.text}`}
          onClick={(e) => {
            e.stopPropagation();
            onSeek(beat.tick);
          }}
        />
      ))}
      <div className="scrubber-cursor" style={{ left: pct(tick) }} />
    </div>
  );
}
